import {DEFAULT_GAME_FIELD, EMPTY_GAME_FIELD, EXPERIMENT_GAME_FIELDS, GAME_FIELDS} from '../../configs/fields';
import {pluralizeRu} from '../other/pluralizeRu';

const getPlayersGroups = () => {
  const counts = [...new Set(GAME_FIELDS.map(({playersCount}) => playersCount))].sort((a, b) => a - b);

  return counts.map((count) => ({
    id: `players_${count}`,
    title: `${count} ${pluralizeRu(count, 'игрок', 'игрока', 'игроков')}`,
    fields: GAME_FIELDS.filter(({playersCount}) => playersCount === count),
  }));
};

/**
 * Разделы экрана выбора карты: боевые поля — по числу игроков. Тестовое,
 * экспериментальные и пустое поля видны только админам. Локально тестовое поле
 * нужно постоянно и стоит первым разделом, на сервере — уходит в конец.
 *
 * @param {Object} options
 * @param {boolean} options.isAdmin — админ или супер-админ
 * @param {boolean} options.isLocalDev — локальная разработка
 * @returns {{id: string, title: string, fields: Object[]}[]}
 */
export const getFieldSelectGroups = ({isAdmin, isLocalDev}) => {
  const playersGroups = getPlayersGroups();
  if (!isAdmin) {
    return playersGroups;
  }

  const experimentFields = [...EXPERIMENT_GAME_FIELDS, EMPTY_GAME_FIELD];
  if (isLocalDev) {
    return [
      {id: 'test', title: 'Для разработки', fields: [DEFAULT_GAME_FIELD]},
      ...playersGroups,
      {id: 'service', title: 'Служебные', fields: experimentFields},
    ];
  }
  return [
    ...playersGroups,
    {id: 'service', title: 'Служебные', fields: [...experimentFields, DEFAULT_GAME_FIELD]},
  ];
};
